import React from 'react';
import { Dropdown, useInputHelper } from 'framework/form';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';
import { SxProps } from '@mui/material';
import { getFullName } from './ownerHelper';

type OwnerDropdownProps = {
  label?: string;
  source: string;
  sales: any[];
  onChangeCallback?: (values: FormFieldsData) => void;
  placeholder?: string;
  disabled?: boolean;
  value?: Nullable<string>;
  className?: string;
  sx?: SxProps;
};

const OwnerDropdown = ({ sales, label, ...props }: OwnerDropdownProps) => {
  const { getLabel, getOnChangeCallback } = useInputHelper({ label, ...props });

  return (
    <Dropdown
      label={getLabel()}
      options={sales.map(employee => ({
        value: employee.alias,
        label: employee.nameEn && getFullName(employee.nameEn),
        disabled: !employee.alias,
      }))}
      onChangeCallback={getOnChangeCallback()}
      {...props}
    />
  );
};

export default OwnerDropdown;
